import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { ASSETS } from "../mock";
import { TERMS } from "../data/termsContent";
import { PRIVACY } from "../data/privacyContent";
import { Footer } from "../components/landing/BottomSections";
import WhatsAppButton from "../components/landing/WhatsAppButton";

const LegalPage = ({ type }) => {
  const doc = type === "terms" ? TERMS : PRIVACY;
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="font-montserrat bg-white min-h-screen">
      {/* Simple header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-[0_1px_0_rgba(0,0,0,0.06)]">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center shrink-0">
            <img src={ASSETS.logo} alt="RapidPay" className="h-9 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-[13px] font-bold text-black px-5 py-2.5 rounded-full border-2 border-black/15 hover:border-black transition-colors duration-200"
          >
            <ArrowLeft size={15} />
            Volver al inicio
          </Link>
        </div>
      </header>

      {/* Title */}
      <div className="bg-[#fafcf9] border-b border-black/[0.05]">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-14 lg:py-20">
          <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-wider text-black bg-[#0fe814] px-3 py-1.5 rounded-full">
            <ShieldCheck size={13} />
            RAPID PAYPRO, S.A.
          </span>
          <h1 data-testid="legal-title" className="mt-5 font-extrabold text-[32px] sm:text-[42px] lg:text-[48px] tracking-tight text-black leading-tight">
            {doc.title}
          </h1>
          {doc.intro && doc.intro !== "Rapid PayPro" && (
            <p className="mt-5 text-[15px] leading-relaxed text-black/60 font-medium max-w-3xl">{doc.intro}</p>
          )}
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
        <div className="space-y-10">
          {doc.sections.map((section, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-bold text-[19px] lg:text-[21px] text-black leading-snug pb-3 border-b-2 border-[#0fe814]/40">
                {section.title}
              </h2>
              <div className="mt-4 space-y-3">
                {section.paragraphs.map((p, j) => (
                  <p key={j} className="text-[14px] leading-relaxed text-black/65 font-medium">
                    {p}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default LegalPage;
